import projection from '../generated/pwd506f1.json';
import { AcceptanceManifest } from '../types';
export const pwd506f1AcceptanceManifest = projection as AcceptanceManifest;
